<template>
    <v-card
        outlined
        class="payment-card py-2 px-4 rounded-lg d-sm-block d-flex"
        :class="{ 'success': success }"
      >
        <v-icon>mdi-account</v-icon>
        <div class="body-1 text-sm-h6">{{ name }}</div>
      </v-card>
</template>

<script>
export default {
    props: {
        success: {
            default: false,
        },
        name: {
            default: ""
        }
    }
}
</script>

<style scoped>
.payment-card {
  text-align: center;
  background: rgba(255, 255, 255, 0.16);
  transition: transform 0.2s ease;
  min-width: 120px;
  gap: 8px;
}
</style>